import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RecordUpdateRequestParams, SelectData} from "../../../../../../../../core/types/records-table.types";
import {
  CreateQualityControlApprovalsData,
  QualityControlApprovalsData
} from "../../types/quality-control-approvals.types";
import {QualityControlApprovalsService} from "../../services/quality-control-approvals.service";
import {qualityControlApprovalsFormFields} from "../../configs/quality-control-approvals-form-fields";
import {qualityControlApprovalsResourceType} from "../../configs/quality-control-approvals-config";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {
  CustomMatSelectComponent
} from "../../../../../../../../shared/components/ui/custom-mat-select/custom-mat-select.component";

@Component({
  selector: 'app-quality-control-approvals-form',
  imports: [
    CdkTextareaAutosize,
    FormsModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    CustomMatSelectComponent
  ],
  templateUrl: './quality-control-approvals-form.component.html',
  styleUrl: './quality-control-approvals-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QualityControlApprovalsFormComponent {
  productCardQualityControlId = input.required<number>()
  qualityControlApprovalData = input.required<QualityControlApprovalsData>();
  qualityControlApprovalsFormGroup = input.required<FormGroup>();
  approvalStatusSelectData = input<Array<SelectData>>([]);
  noFirstData = input<boolean>(false);
  isEditModeActive = input<boolean>(false);
  updateData = output<QualityControlApprovalsData>();
  deleteData = output<void>();
  setLoadingState = output<boolean>();

  private qualityControlApprovalsService: QualityControlApprovalsService = inject(QualityControlApprovalsService);

  public readonly qualityControlApprovalsFormFields = qualityControlApprovalsFormFields;

  public getFieldClass(): string {
    if (!this.qualityControlApprovalData().id) { return ''; }

    return this.isEditModeActive() ? '' : 'none-pointer-events';
  }

  public async handleValueChange(key: string): Promise<void> {
    if (!this.qualityControlApprovalData().id) { return; }

    const params: RecordUpdateRequestParams = {
      path: qualityControlApprovalsResourceType.path,
      recordId: this.qualityControlApprovalData().id,
      fieldName: key,
      value: this.qualityControlApprovalsFormGroup().get(key)?.value
    };

    const data = await this.qualityControlApprovalsService.updatedRecordField<QualityControlApprovalsData>(params)
      .catch(() => this.qualityControlApprovalData());
    this.updateData.emit(data);
  }

  public handleSelectChange(value: string, key: string): void {
    this.qualityControlApprovalsFormGroup().get(key)?.setValue(value);
  }

  public handleDeleteData(): void {
    this.deleteData.emit();
  }

  public async handleCreateData(): Promise<void> {
    this.setLoadingState.emit(true);
    const params: CreateQualityControlApprovalsData = {
      productCardQualityControlId: this.productCardQualityControlId(),
      ...this.qualityControlApprovalsFormGroup().value
    };

    await this.qualityControlApprovalsService.createQualityControlApprovalsData(params)
      .then((data) => this.updateData.emit(data))
      .finally(() => this.setLoadingState.emit(false));
  }
}
